export const emptyUser = {
  userid: 0,
  username: "",
  email: "",
  creationdate: "",
  firstname: "",
  secondname: "",
  firstlastname: "",
  secondlastname: "",
  telephone: "",
  address: "",
  birthday: "",
  idarea: 0,
  idcompany: 0,
  role: "",
  seniority: "",
  state: "",
  areaname: "",
  picture: null
}
